import { RequiredRule, StringLengthRule } from 'devextreme-react/data-grid';
import React from 'react';
import styles from './undercutInputTab.module.scss';

const fillUndecutDataGrid = [
  {
    dataField: 'sku',
    caption: 'SKU полосы',
    dataType: 'string',
    allowEditing: false
  },
  {
    dataField: 'width',
    caption: 'Ширина полосы',
    dataType: 'number',
    allowEditing: false
  },
  {
    dataField: 'numberLine',
    caption: 'Номер полосы',
    cssClass: styles.editableCell,
    validationRule: (
      <StringLengthRule
        min={4}
        max={4}
        message="Номер полосы должен содержать 4 цифры"
      />
    ),
    dataType: 'number',
    allowEditing: true
  },
  {
    dataField: 'weight',
    caption: 'Фактическое кол-во',
    dataType: 'number',
    cssClass: styles.editableCell,
    validationRule: (
      <RequiredRule message="Фактическое кол-во не может быть пустым" />
    ),
    allowEditing: true
  }
];

export default fillUndecutDataGrid;
